import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import userSlice from './slices/userSlice';
import practiceSlice from './slices/practiceSlice';
import patientSlice from './slices/patientSlice';
import measurementSlice from './slices/measurementSlice';
import questionnaireSlice from './slices/questionnaireSlice';
import chatSlice from './slices/chatSlice';
import uiSlice from './slices/uiSlice';
import adminSlice from './slices/adminSlice';
import providerSlice from './slices/providerSlice';
import caregiverSlice from './slices/caregiverSlice';
import systemCaregiverSlice from './slices/systemCaregiverSlice';
import settingsSlice from './slices/settingsSlice';
import inventorySlice from './slices/inventorySlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    practice: practiceSlice,
    patient: patientSlice,
    measurement: measurementSlice,
    questionnaire: questionnaireSlice,
    chat: chatSlice,
    ui: uiSlice,
    admin: adminSlice,
    provider: providerSlice,
    caregiver: caregiverSlice,
    systemCaregiver: systemCaregiverSlice,
    settings: settingsSlice,
    inventory: inventorySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Store configured successfully

export default store;
